import { createFileRoute } from "@tanstack/react-router";
import Otp from "@/auth/otp";

export const Route = createFileRoute("/(auth)/otp")({
  component: Otp,
});
